import component from './component';
import { initialPageSetup } from './api';

export default component;

export { initialPageSetup };
